// --------------------------------------------------------------------------------
// Angular Imports
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Configuration } from './app.constants';
import { routing } from './app.routes';
import { HttpModule, JsonpModule, Http, Headers, RequestOptions } from '@angular/http';

// --------------------------------------------------------------------------------
// Materilize CSS Import
import 'materialize-css';

// --------------------------------------------------------------------------------
// App Imports
import { AppComponent } from './app.component';

// --------------------------------------------------------------------------------
// Unauthorized & Forbidden Imports
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

// --------------------------------------------------------------------------------
// Auth Imports
import { AuthModule } from './auth/modules/auth.module';
import { OidcSecurityService } from './auth/services/oidc.security.service';
import { OpenIDImplicitFlowConfiguration } from './auth/modules/auth.configuration';

// --------------------------------------------------------------------------------
// Guard Imports
import { IsAuthenticatedGuard } from './guards/isAuthenticatedGuard';

// --------------------------------------------------------------------------------
// Sheet Imports
import { SheetWidgetComponent } from './shared/sheet-export-import/sheet-widget/sheet-widget.component';

// --------------------------------------------------------------------------------
// Notifcation Imports
import { NotificationHandlerService } from './shared/notifications/notification-handler.service';

// --------------------------------------------------------------------------------
// Shared Module Imports
import { SharedModule } from './shared.module';

import { HttpClientModule } from '@angular/common/http';

// --------------------------------------------------------------------------------
// QR COde Generator Import
import { QRCodeModule } from 'angularx-qrcode';


@NgModule({
    imports: [
        QRCodeModule,
        SharedModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        routing,
        HttpModule,
        HttpClientModule,
        JsonpModule,
        BrowserAnimationsModule,
        AuthModule.forRoot()
    ],
    declarations: [
        AppComponent,
        SheetWidgetComponent,
        ForbiddenComponent,
        UnauthorizedComponent
    ],
    providers: [
        NotificationHandlerService,
        OidcSecurityService,
        Configuration,
        IsAuthenticatedGuard
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule {

    clientConfiguration: any;

    constructor(public oidcSecurityService: OidcSecurityService, private _notificationService: NotificationHandlerService, private http: Http, private configuration: Configuration) {

        //console.log('APP STARTING');
        this.configClient().subscribe(config => {

            let openIDImplicitFlowConfiguration = new OpenIDImplicitFlowConfiguration();
            openIDImplicitFlowConfiguration.stsServer = this.clientConfiguration.stsServer;
            openIDImplicitFlowConfiguration.redirect_url = this.clientConfiguration.redirect_url;
            // The Client MUST validate that the aud (audience) Claim contains its client_id value registered at the Issuer identified by the iss (issuer) Claim as an audience.
            // The ID Token MUST be rejected if the ID Token does not list the Client as a valid audience, or if it contains additional audiences not trusted by the Client.
            openIDImplicitFlowConfiguration.client_id = this.clientConfiguration.client_id;
            openIDImplicitFlowConfiguration.response_type = this.clientConfiguration.response_type;
            openIDImplicitFlowConfiguration.scope = this.clientConfiguration.scope;
            openIDImplicitFlowConfiguration.post_logout_redirect_uri = this.clientConfiguration.post_logout_redirect_uri;
            openIDImplicitFlowConfiguration.start_checksession = this.clientConfiguration.start_checksession;
            openIDImplicitFlowConfiguration.silent_renew = this.clientConfiguration.silent_renew;
            openIDImplicitFlowConfiguration.startup_route = this.clientConfiguration.startup_route;
            // HTTP 403
            openIDImplicitFlowConfiguration.forbidden_route = this.clientConfiguration.forbidden_route;
            // HTTP 401
            openIDImplicitFlowConfiguration.unauthorized_route = this.clientConfiguration.unauthorized_route;
            openIDImplicitFlowConfiguration.log_console_error_active = this.clientConfiguration.log_console_error_active;
            openIDImplicitFlowConfiguration.log_console_warning_active = this.clientConfiguration.log_console_warning_active;
            openIDImplicitFlowConfiguration.log_console_debug_active = this.clientConfiguration.log_console_debug_active;
            // id_token C8: The iat Claim can be used to reject tokens that were issued too far away from the current time,
            // limiting the amount of time that nonces need to be stored to prevent attacks.The acceptable range is Client specific.
            openIDImplicitFlowConfiguration.max_id_token_iat_offset_allowed_in_seconds = this.clientConfiguration.max_id_token_iat_offset_allowed_in_seconds;
            //openIDImplicitFlowConfiguration.storage = typeof Storage !== 'undefined' ? sessionStorage : null;
            openIDImplicitFlowConfiguration.storage = sessionStorage;

            this.oidcSecurityService.setupModule(openIDImplicitFlowConfiguration);

            configuration.FileServer = this.clientConfiguration.apiFileServer;
            configuration.Server = this.clientConfiguration.apiServer;

            this._notificationService.updateErrorLog(this.clientConfiguration.log_console_error_active);
            this._notificationService.updateConsoleLog(this.clientConfiguration.log_console_debug_active);
            this._notificationService.updateToastLog(this.clientConfiguration.log_toast_debug_active);
        });
    }

    configClient() {

        //console.log('window.location', window.location);
        //console.log('window.location.href', window.location.href);
        //console.log('window.location.origin', window.location.origin);
        //console.log('PATHNAME>>>>>>>', window.location.pathname);

        return this.http.get(window.location.origin + '/api/ClientAppSettings/' + window.location.pathname.substr(1)).map(res => {
            //console.log(res.json());
            this.clientConfiguration = res.json();
            //this.clientConfiguration.startup_route = 'units';
        });
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/app.module.ts